import { Nullable } from '@/shared/types/app.types'
import { AlarmType, CustomConfiguration } from '@/modules/configurationModule/detail/notifications/models/alarms'

export enum alarmNotificationTypeWithCustomConfiguration {
    REQUEST_REGISTER_DELAY = 'REQUEST_REGISTER_DELAY',
    CASE_PROXIMITY_TO_GLOBAL_TARGET_DATE = 'CASE_PROXIMITY_TO_GLOBAL_TARGET_DATE',
    CASE_PROXIMITY_TO_DIAGNOSTIC_TARGET_DATE = 'CASE_PROXIMITY_TO_DIAGNOSTIC_TARGET_DATE',
    SAMPLE_GROSSING_DELAY = 'SAMPLE_GROSSING_DELAY',
    SAMPLE_SHELF_DELAY = 'SAMPLE_SHELF_DELAY',
    SAMPLE_DISCARD_DELAY_REMINDER = 'SAMPLE_DISCARD_DELAY_REMINDER',
    REQUEST_UNLOCK_DELAY = 'REQUEST_UNLOCK_DELAY',
    REQUEST_AP_REPORT_VISUALIZATION_DELAY = 'REQUEST_AP_REPORT_VISUALIZATION_DELAY',
    COMPLEMENTARY_AP_REPORT_VISUALIZATION_DELAY = 'COMPLEMENTARY_AP_REPORT_VISUALIZATION_DELAY'
}

export interface AlarmGeneralConfiguration {
    alarmType: Nullable<AlarmType>,
    initialWindowInMinutes: Nullable<number>,
    cronExpression: string
}

export interface AlarmsModalState {
    id?: Nullable<number>
    active: boolean,
    generalConfiguration: AlarmGeneralConfiguration,
    customConfiguration: CustomConfiguration
}
export const initialAlarmsModalState =
    (): AlarmsModalState => ({
        active: true,
        id: null,
        generalConfiguration: {
            alarmType: null,
            initialWindowInMinutes: null,
            cronExpression: ''
        },
        customConfiguration: {
            receiverPersonnelIds: [],
            receiverPersonnelList: [],
            daysToDiagnosticTargetDateList: [],
            daysToRemindSampleDiscardDelayed: null,
            daysToGlobalTargetDateList: [],
            daysToDelay: null,
            daysBeforeUnlockDelay: null,
            shouldNotifyPhysicianPetitioner: false,
            shouldNotifyPhysicianDepartment: false
        }
    })
